import * as React from 'react';

function SvgComponent(props) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M2.233 17.708c.267 2.29 2.201 4.11 4.593 4.22 1.653.077 3.341.116 5.174.116 1.833 0 3.521-.04 5.174-.116 2.392-.11 4.326-1.93 4.593-4.22.37-3.182.37-5.89 0-9.072-.267-2.29-2.201-4.11-4.593-4.22A110.621 110.621 0 0012 4.299c-1.833 0-3.521.04-5.174.117-2.392.11-4.326 1.93-4.593 4.22-.37 3.181-.37 5.89 0 9.072zM7.583 1.955v4.42M16.416 1.955v4.42"
                stroke="currentColor"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.585 12.055c-.257 0-.401-.145-.401-.402s.144-.402.401-.402M7.588 12.055c.258 0 .402-.145.402-.402s-.144-.402-.402-.402M7.585 16.876c-.257 0-.401-.145-.401-.402s.144-.402.401-.402M7.588 16.876c.258 0 .402-.145.402-.402s-.144-.402-.402-.402M11.997 12.055c-.257 0-.402-.145-.402-.402s.145-.402.402-.402M12 12.055c.257 0 .402-.145.402-.402s-.145-.402-.402-.402M11.997 16.876c-.257 0-.402-.145-.402-.402s.145-.402.402-.402m.003.804c.257 0 .402-.145.402-.402s-.145-.402-.402-.402M16.402 16.876c-.257 0-.402-.145-.402-.402s.145-.402.402-.402m.003.804c.257 0 .402-.145.402-.402s-.145-.402-.402-.402M16.412 12.055c-.257 0-.402-.145-.402-.402s.145-.402.402-.402M16.415 12.055c.257 0 .402-.145.402-.402s-.145-.402-.402-.402"
                stroke="currentColor"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default SvgComponent;
